import type {JSX} from 'react';
import {createRoot} from 'react-dom/client';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import '@prtimes-basis/styles/reset.css';
import '@prtimes-basis/styles/global.css';
import ApiProvider from '@/contexts/api-context';
import {CompanyDetailTemplate} from '@/features/company-detail/templates/pc/company-detail-template';
import {CompanyDetailContextProvider} from '@/features/company-detail/contexts/company-detail-context-provider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

function App(): JSX.Element {
  return (
    <ApiProvider>
      <QueryClientProvider client={queryClient}>
        <CompanyDetailContextProvider>
          <CompanyDetailTemplate />
        </CompanyDetailContextProvider>
      </QueryClientProvider>
    </ApiProvider>
  );
}

const container = document.querySelector('#root');
if (container !== null) createRoot(container).render(<App />);
